import ZoomOutSVG from "@design-system/ui-icons/vanilla/ZoomOut"
import { createIcon } from "../createIcon"

export const ZoomOutIcon = createIcon(ZoomOutSVG)
